/**
 * Type guard that checks whether a value is a plain record object.
 */
export const isRecord = (value: unknown): value is Record<string, unknown> =>
	typeof value === 'object' && value !== null && !Array.isArray(value);
